import axios, { AxiosError } from "axios";
import { authService } from "./AuthService";

const api = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_SERVER_URL,
});

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      // Log out the user
      authService.logOut();
      // Redirect to login page
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);


export default api;
